<template>
    <div class="ap-sidebar-container">
        <div class="ap-sidebar-menu-container">
            <div class="ap-sidebar-menu-element" :class="{'active-page': activePage === 'adminProducts'}" v-on:click="openPage('adminProducts')">
                <div class="ap-sidebar-menu-element-icon">
                    <SVGAdminProducts class="ap-sidebar-svg"/>
                </div>
                <div class="ap-sidebar-menu-element-name">
                    Продукция
                </div>
            </div>
            <div class="ap-sidebar-menu-element" :class="{'active-page': activePage === 'AdminCategories'}" v-on:click="openPage('AdminCategories')">
                <div class="ap-sidebar-menu-element-icon">
                    <SVGAdminCategories class="ap-sidebar-svg"/>
                </div>
                <div class="ap-sidebar-menu-element-name">
                    Категории
                </div>
            </div>
            <div class="ap-sidebar-menu-element" :class="{'active-page': activePage === 'adminProjects'}" v-on:click="openPage('adminProjects')">
                <div class="ap-sidebar-menu-element-icon">
                    <SVGAdminProjects class="ap-sidebar-svg"/>
                </div>
                <div class="ap-sidebar-menu-element-name">
                    Проекты
                </div>
            </div>
            <div class="ap-sidebar-menu-element" :class="{'active-page': activePage === 'adminIncoming'}" v-on:click="openPage('adminIncoming')">
                <div class="ap-sidebar-menu-element-icon">
                    <SVGMail class="ap-sidebar-svg-fa"/>
                </div>
                <div class="ap-sidebar-menu-element-name">
                    Заявки
                </div>
            </div>
            <div class="ap-sidebar-menu-element" :class="{'active-page': activePage === 'adminCustomers'}" v-on:click="openPage('adminCustomers')">
                <div class="ap-sidebar-menu-element-icon">
                    <SVGAdminCustomers class="ap-sidebar-svg"/>
                </div>
                <div class="ap-sidebar-menu-element-name">
                    Заказчики
                </div>
            </div>
            <div class="ap-sidebar-menu-element" :class="{'active-page': activePage === 'adminUsers'}" v-on:click="openPage('adminUsers')">
                <div class="ap-sidebar-menu-element-icon">
                    <SVGAdminUsers class="ap-sidebar-svg"/>
                </div>
                <div class="ap-sidebar-menu-element-name">
                    Пользователи
                </div>
            </div>
            <div class="ap-sidebar-menu-element" :class="{'active-page': activePage === 'adminOrganizations'}" v-on:click="openPage('adminOrganizations')">
                <div class="ap-sidebar-menu-element-icon">
                    <SVGAdminOrganizations class="ap-sidebar-svg"/>
                </div>
                <div class="ap-sidebar-menu-element-name">
                    Организации
                </div>
            </div>
            <div class="ap-sidebar-menu-element" :class="{'active-page': activePage === 'adminConfig'}" v-on:click="openPage('adminConfig')">
                <div class="ap-sidebar-menu-element-icon">
                    <SVGWrench class="ap-sidebar-svg"/>
                </div>
                <div class="ap-sidebar-menu-element-name">
                    Конфигурация
                </div>
            </div>
        </div>
        <div class="ap-sidebar-menu-configurator-btn" v-on:click="openPage('projects')">
            <div class="ap-sidebar-menu-element-icon">
                <SVGArrowLeft/>
            </div>
            <div class="ap-sidebar-menu-element-name">
                К конфигуратору
            </div>
        </div>
    </div>
</template>

<script>
    import SVGAdminProducts from "../../SVG/SVGAdminProducts";
    import SVGAdminProjects from "../../SVG/SVGAdminProjects";
    import SVGAdminCustomers from "../../SVG/SVGAdminCustomers";
    import SVGAdminUsers from "../../SVG/SVGAdminUsers";
    import SVGAdminOrganizations from "../../SVG/SVGAdminOrganizations";
    import SVGAdminCategories from "../../SVG/SVGAdminCategories";
    import SVGArrowLeft from "../../SVG/SVGArrowLeft";
    import SVGMail from "../../SVG/SVGMail";
    import SVGWrench from "../../SVG/SVGWrench";

    export default {
        name: "SidebarAdminPage",
        components: {
            SVGWrench,
            SVGMail,
            SVGArrowLeft,
            SVGAdminCategories,
            SVGAdminOrganizations,
            SVGAdminUsers,
            SVGAdminCustomers,
            SVGAdminProjects,
            SVGAdminProducts
        },
        computed: {
            activePage() {
                return this.$store.state.route.name
            }
        },
        methods: {
            openPage(name) {
                this.$router.push({name: name}).catch(() => {})
            },
        }
    }
</script>

<style scoped>

</style>
